import $ from 'jquery';

export default function () {
    if ($('.faq').length) {
        $(".faq__item").click(function () {
            const itemDesc = ".faq__item-description";
            const itemToggle = ".faq__item-toggle"
            const itemContainer = $(".faq .faq__item");
            const itemActive = "active";

            $(itemContainer).find(itemDesc).addClass(itemActive);

            for (let i = 0; i < itemContainer.length; i++) {
                const element = itemContainer[i];
                $(element).find(itemDesc).slideUp();
                $(element).find(itemToggle).removeClass(itemActive)
            }

            if ($(this).find(itemDesc).is(":hidden")) {
                $(this).find(itemDesc).slideDown();
                $(this).find(itemToggle).addClass(itemActive)
            } else {
                $(this).find(itemDesc).slideUp();
                $(this).find(itemToggle).removeClass(itemActive)
            }
        });
    }
}
